
import {
  GENRE_TYPES,
  REGION_MARKET_TYPES
} from "@/pages/intelligence/pages/GlobalView/components/TopMarketGenreCore/constants";

const MonetizationModel = {
  namespace: 'intelligence_global_view_market_genre',

  state: {
    filter: {
      regionType: REGION_MARKET_TYPES.REGION,
      years: [],
      genreType: GENRE_TYPES.MAIN,
      dateValue: ['', ''],
      genres: [],
      mainGenres: [],
      subGenres: [],
      regions: [],
      markets: [],
    },
    // 上一次选中的perType，用于重置筛选器
    lastPerType: '',
    // 接下来三个均用于继承逻辑
    lastRevenueType: '',
    lastRegionType: '',
    lastGenreType: '',
    // 从非手游到手游或手游到非手游，如果没有选项继承时，记录当前选中的指标（区域、市场、品类）
    lastSelectedMetric: null,
    // 记录筛选器是否有被改变过
    isFilterChangeBefore: false,
  },

  reducers: {
    setFilter(state: any, action: any) {
      const { key, payload } = action;
      return {
        ...state,
        filter: {
          ...state?.filter,
          [key]: payload
        }
      };
    },
    setLastPerType(state: any, action: any) {
      return {
        ...state,
        lastPerType: action.payload
      };
    },
    setLastRevenueType(state: any, action: any) {
      return {
        ...state,
        lastRevenueType: action.payload
      };
    },
    setLastRegionType(state: any, action: any) {
      return {
        ...state,
        lastRegionType: action.payload
      };
    },
    setLastGenreType(state: any, action: any) {
      return {
        ...state,
        lastGenreType: action.payload
      };
    },
    setLastSelectedMetric(state: any, action: any) {
      return {
        ...state,
        lastSelectedMetric: action.payload
      };
    },
    setFilterChangeBeforeFlag(state: any, action: any) {
      return {
        ...state,
        isFilterChangeBefore: action.payload
      };
    },
  }
};

export default MonetizationModel;
